import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { toast } from "sonner";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { GreetingTable, useBirthdayAction } from "@/components/birthdays/BirthdayToday";
import { Download } from "lucide-react";

const FILTERS = [["", "All"], ["sent", "Sent"], ["problems", "Failed / uncertain"], ["skipped", "Skipped"], ["cancelled", "Cancelled"]];

export const BirthdayHistory = () => {
  const act = useBirthdayAction();
  const [search, setSearch] = useState("");
  const [status, setStatus] = useState("");
  const { data = [], isLoading } = useQuery({ queryKey: ["birthdays", "history", search.trim(), status],
    queryFn: async () => (await api.get("/birthdays/history", { params: { search: search.trim(), status } })).data });

  const exportCsv = async () => {
    try {
      const res = await api.get("/birthdays/export", { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      Object.assign(document.createElement("a"), { href: url, download: `birthday-greetings-${new Date().getFullYear()}.csv` }).click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Export failed");
    }
  };

  return (
    <div className="space-y-3" data-testid="bday-history">
      <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
        <Input data-testid="bday-history-search" className="sm:max-w-xs" placeholder="Search patient name" value={search} onChange={(e) => setSearch(e.target.value)} />
        <div className="flex flex-wrap gap-1.5">
          {FILTERS.map(([k, l]) => <Button key={k || "all"} size="sm" variant={status === k ? "default" : "outline"} className={status === k ? "bg-[#0B1F44]" : ""}
            onClick={() => setStatus(k)} data-testid={`bday-filter-${k || "all"}`}>{l}</Button>)}
        </div>
        <Button size="sm" variant="outline" className="sm:ml-auto" onClick={exportCsv} data-testid="bday-export"><Download className="mr-1 h-4 w-4" />Export report</Button>
      </div>
      <GreetingTable rows={data} act={act} showDate empty={isLoading ? "Loading…" : "No greetings this year match."} />
    </div>
  );
};
